// On phones the trending pills become a single row that scrolls sideways forever: the pills are cloned once so the
// loop is seamless. Touching the row pauses it. On wider screens the normal grid is restored.
const grid = document.querySelector('[data-trending-grid]');
if (grid) {
  const mobile = window.matchMedia('(max-width: 749px)');
  let clones = [];

  const enable = () => {
    if (clones.length) return;
    const items = Array.from(grid.children);
    clones = items.map((item) => {
      const copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('tabindex', '-1');
      return copy;
    });
    grid.append(...clones);
    grid.style.setProperty('--trending-duration', `${Math.max(items.length * 3.5, 24)}s`);
    grid.classList.add('is-marquee');
  };

  const disable = () => {
    clones.forEach((clone) => clone.remove());
    clones = [];
    grid.classList.remove('is-marquee', 'is-paused');
    grid.style.removeProperty('--trending-duration');
  };

  const sync = () => (mobile.matches ? enable() : disable());
  sync();
  mobile.addEventListener('change', sync);
  grid.addEventListener('touchstart', () => grid.classList.add('is-paused'), { passive: true });
  grid.addEventListener('touchend', () => setTimeout(() => grid.classList.remove('is-paused'), 1500), { passive: true });
}
